import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import moment from "moment";
import {
  getTestData,
  downloadTestData,
  getYieldTestData,
  getAmortTestData,
  downloadAmortTestData
} from "store/state/calculators/testHarness";
import {
  LIBOR_FORWARD_CURVE,
  CAP_VOLS,
  MARKET_EXPECTATIONS_SHOCK,
  TREASURIES,
} from "../Constants/Constants";
import {FIXED_RATE} from '../Constants/InterestRateType';
import YieldTestHarnessSearch from "./Yields/YieldTestHarnessSearch";
import TablePaginationHelper from "../../../utils/tablePaginationHelper";

class YieldCurves extends Component {
  state = {
    dayOfMonth: new Date().getDate(),
    curve: LIBOR_FORWARD_CURVE,
    shockType: MARKET_EXPECTATIONS_SHOCK,
    shockValue: 0,
    baseDate: moment(),
    tenorValue: 0,
    selectedTab: 3,

    loanAmount: 25000000,
    interestRateType: FIXED_RATE,
    interestRate: 0.0425,
    spread: "",

    startDate: moment(),
    loanTerm: 120,
    dayCount: "ACTUAL_OVER_365",
  };

  tablePaginationHelper = new TablePaginationHelper("116cdd2f-5ab4-4399-9d48-536ee613e438", 10);

  submit = () => {
    const options = { ...this.state };
    options.page = this.tablePaginationHelper.page;
    options.pageSize = this.tablePaginationHelper.rowsPerPage;
    options.baseDate = options.baseDate.format("YYYY-MM-DD");    
    this.props.getTestData(options);
  };

  submitYield = () => {
    const options = {
      curve: this.state.curve,
      tenorValue: this.state.tenorValue
    };
    this.props.getYieldTestData(options);
  };

  downloadTestData = () => {
    const options = { ...this.state, page: -1, pageSize: -1 };
    this.props.downloadTestData(options);
  };

  handleTabChange = (event, value) => {
    const defaultCurve = value === 0 ? LIBOR_FORWARD_CURVE : TREASURIES;
    this.setState({ ...this.state, curve: defaultCurve, selectedTab: value });
    this.props.testHarness.testData = null;
  };

  handleChange = ({ target: { name, value } }) => {
    this.setState({
      [name]: value
    });

    if (name === "shockType" && value === MARKET_EXPECTATIONS_SHOCK) {
      this.setState({
        shockValue: 0
      });
    } else if (name === "curve" && value === CAP_VOLS) {
      this.setState({
        shockType: MARKET_EXPECTATIONS_SHOCK
      });
    }
    this.props.testHarness.testData = null;
  };

  handleDateChange = date => {
    this.setState({
      baseDate: date
    });
  };

  handleChangePage = (event, newPage) => {
    if (!event) {
      return null;
    }

    this.tablePaginationHelper.page = newPage;
    this.submit();
  };

  handleChangeRowsPerPage = event => {
    this.tablePaginationHelper.rowsPerPage = event.target.value;
    this.submit();
  };

  render() {
    return (
      <Fragment>
        <YieldTestHarnessSearch
          submit={this.submitYield}
          handleChange={this.handleChange}
          state={this.state}
        />
      </Fragment>
    );
  }
}

const mapStateToProps = ({ authentication, testHarness }) => ({
  authentication,
  testHarness
});

export default compose(
  connect(
    mapStateToProps,
    {
      getTestData,
      downloadTestData,
      getYieldTestData,
      getAmortTestData,
      downloadAmortTestData
    }
  )
)(YieldCurves);
